import { type FlowPermissionEntityType, type FlowRebacPermission } from 'flow-schema';
import { createContext } from 'react';

import type * as api from 'vivaa-api';

export { EntityPermission } from './permissions.js';

interface CommonContext {
  getLoggedIn(): LoggedInContext;
  refreshLoginCheck: () => void;
  permissions: api.Group.Permission[];
  featureFlags: api.FeatureFlag.Setting[];
  allUserRebacPermissions: Partial<
    Record<FlowPermissionEntityType, Record<string, FlowRebacPermission[]>>
  >;
}

interface PendingContext extends CommonContext {
  status: 'pending';
}

export interface LoggedInContext extends CommonContext {
  status: 'resolved';
  user: api.User.UserWithOrganizations;
  logout: () => Promise<void>;
}
interface LoggedOutContext extends CommonContext {
  status: 'resolved';
  user: undefined;
  logout: () => Promise<void>;
}

interface ErrorContext extends CommonContext {
  status: 'rejected';
  error: Error;
}

export type AnyContext = ErrorContext | PendingContext | LoggedInContext | LoggedOutContext;

export const AuthContext = createContext<AnyContext>(
  // Will be provided immediately by AuthManager
  undefined as unknown as PendingContext
);
AuthContext.displayName = 'AuthContext';
